import {darken, mix, transparentize} from '../utils/color-utils';

export const baseColors = {
  white: '#FFFFFF',
  black: '#000000',
  brand50: '#F3FAF4',
  brand100: '#E3F5E6',
  brand200: '#C8EACE',
  brand400: '#6ABE7A',
  brand500: '#409650',
  brand600: '#348543',
  brand800: '#275430',
  brand900: '#22452A',
  gray100: '#F2F3F3',
  gray200: '#D2D4D3',
  gray400: '#919595',
  gray600: '#686E6E',
  gray900: '#040E0D',
  oldTeal: '#298784',
  blue100: '#E5F0FE',
  blue500: '#0058BA',
  red100: '#F9E6E6',
  red500: '#CE131C',
  red600: '#A72824',
  orange50: '#FAEEE6',
  orange600: '#E17115'
};

export const commonPalette = {
  sgGreen: baseColors.brand800,
  btnGreen: baseColors.brand800,
  lightGreen: '#B9D6D5',
  txBlack: '#333330',
  txGrey: '#757575',
  txLightGrey: '#A3A3A3',
  borderGrey: '#ECECEC',
  darkerGray: '#f6f6f6',
  darkestGray: '#f3f3f3',
  darkGreen: '#18454c',
  gray: '#fafafa',
  red: '#c00',
  txboxValue: '#2e2e2e',
  txboxPlaceholder: transparentize('#2e2e2e', 0.6),
  hoverGrey: '#F2F2F2',
  lightGrey: '#F9F9F9',
  orange: '#F79320',
  white: '#FFF',
  disabledText: '#ECECEC',
  lighterGray: '#b3b3b3',
  brightGreen: '#67D155',
  newRed: '#C33F38',
  smartSkillsGreen: '#d9f9e1',
  linkBlue: '#108ee9',
  bannerInformational: '#EBF2F9',
  bannerWarning: '#FDF4ED',
  feedbackWarning: baseColors.orange600,
  feedbackWarningBackground: baseColors.orange50,
  blue: '#1649c0',
  feedbackError: baseColors.red600,
  bannerError: '#FEF3F3',
  feedbackSuccess: baseColors.oldTeal,
  feedbackErrorBackground: baseColors.red100,
  feedbackSuccessBackground: baseColors.brand50,
  feedbackInformational: baseColors.blue500,
  feedbackInformationalBackground: baseColors.blue100,
  bannerSuccess: '#EBF7F7',
  iconDefault: baseColors.gray600,
  surfaceGray2: '#F7F7F7',
  bannerDefault: '#F7F7F7',
  btnHoverGreen: darken(baseColors.brand800, 0.15),

  interactionHover: mix(baseColors.white, baseColors.brand900, 0.05),
  interactionPressed: mix(baseColors.white, baseColors.brand900, 0.1),
  interactionHoverTransparent: transparentize(mix(baseColors.white, baseColors.brand900, 0.05), 0.5),
  interactionPressedTransparent: transparentize(mix(baseColors.white, baseColors.brand900, 0.1), 0.5),
  highlightYellow: '#FFFF99',
  strokeDefault: baseColors.gray400,
  strokeLowContrast: baseColors.gray100,
  textBrand: '#348543',
  textSecondary: baseColors.gray600,
  textInverse: baseColors.white,
  textPrimary: baseColors.gray900,
  whiteSmoke: baseColors.gray100,
  darkCharcoal: '#323232',
  black: baseColors.black,
  silver: '#EDEDED',
  blue600: '#275DBF',
  blue200: '#B2D1FB',
  orange300: '#F7C36E',
  strokeDivider: baseColors.gray200,
  // Design system green
  surfaceBrand: '#275430',
  surfaceBackdrop: transparentize(baseColors.gray900, 0.1),
  surfaceIconBackground: transparentize(baseColors.gray900, 0.7),
  surfaceLevel2: baseColors.gray100,
  surfaceDefault: baseColors.white,
  iconBrand: '#348543',
  interactionPrimaryHover: '#2C6938',
  interactionPrimaryPressed: '#348543',
  interactionSelected: baseColors.brand50,
  interactionDragSelected: transparentize(baseColors.oldTeal, 0.15),
  strokeBrand: baseColors.brand600,
  strokeInverse: baseColors.white,
  surfaceGhost: transparentize(baseColors.brand200, 0.8),
  focusShadow: `0px 0px 0px 1px ${baseColors.white}, 0px 0px 0px 3px ${baseColors.brand500}`,
  elevation1: `0px 0px 4px 0px ${transparentize(baseColors.black, 0.08)}, 0px 7px 8px 0px ${transparentize(
    baseColors.black,
    0.04
  )}`,
  elevation3: `0px 4px 10px 0px ${transparentize(baseColors.black, 0.12)}, 0px 1px 4px 0px ${transparentize(
    baseColors.black,
    0.16
  )}`
};

export const activityLogColors = {
  green: '#D2E7E6',
  lightGreen: '#E9F3F2',
  lightRed: '#E8C1BF'
};

export const checklistColors = {
  green: '#7BD398',
  red: '#E32C2C',
  white: '#FFF'
};

export const toastNotificationsColors = {
  darkGrey: '#5D5D5B',
  red: '#D3302F'
};

export const legacyPalette = {
  uploadDropzoneBackground: '#EAEAEA',
  uploadDropzoneHoverBackground: '#dcd9d9',
  uploadDropzoneBorder: 'rgba(51, 51, 51, 0.3)'
};
